import { Box, useTheme } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { eventService } from '../../../shared/services/tenant/eventService';
import { Card } from '../../../shared/components/ui/Card';
import { ModalDelete } from '../components/ModalDelete';
import { useEvent } from '../context/useEvent';
import { PageHeader } from '../components/EventDetail/PageHeader';
import { ActionButtons } from '../components/EventDetail/ActionButtons';
import { EventInfo } from '../components/EventDetail/EventInfo';
import { useState } from 'react';

export default function EventDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { removeEvent } = useEvent();
  const theme = useTheme();

  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const { data, isLoading } = useQuery({
    queryKey: ['event', id],
    queryFn: () => eventService.get(id!).then(res => res.data),
    
    enabled: !!id
  });

  if (isLoading) return null;
  if (!data) return null;

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await removeEvent(data.id);
      setDeleteModalOpen(false);
      navigate('/events');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleEdit = () => {
    navigate(`/events/${data.id}/edit`);
  };
  
  return (
    <Box sx={{ p: { xs: 1, md: 4 }, background: theme.palette.background.default, minHeight: '100vh' }}>
      <Card sx={{ background: theme.palette.background.paper, borderRadius: 4, p: 4, maxWidth: 900, margin: '32px auto', boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)' }}>
        <PageHeader onBack={() => navigate('/events')} />
        <ActionButtons 
          onEdit={handleEdit}
          disableDelete={data?.participants?.length > 0}
          onDelete={() => setDeleteModalOpen(true)}
        />
        <EventInfo event={data} />

        <ModalDelete
          open={isDeleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
          onConfirm={handleDelete}
          loading={isDeleting}
          companyName={data.title}
        />
      </Card>
    </Box>
  );
}